import jQuery from 'jquery';
import ready from '../util/ready';
import {log} from "../util/logger";

const debounce = require("lodash/debounce");

export default function ($ = jQuery) {
  ready(() => {
    const $sidebarEl = $('aside.sidebar');
    const $sidebarInnerEl = $('aside.sidebar > .sidebar__inner');

    if ($sidebarEl.length === 0) {
      return;
    }

    /*
     * Set the left sidebar as fixed when possible
     */
    const scrollCheck = function () {
      if (!$sidebarEl.is(':visible')) {
        return;
      }

      setTimeout(function () {
        if ($(window).height() > $sidebarInnerEl.height()) {
          $sidebarEl.addClass('is-fixed');
          return;
        }

        $sidebarEl.removeClass('is-fixed');
      }, 10);
    };

    $(window).on('load resize scroll', debounce(scrollCheck, 150));

    log('Sidebar init');
  });
};
